(function () {
  const breakpoint = window.matchMedia('(max-width: 900px)');

  function initWhyUs(section) {
    if (section.dataset.rfWhyusMobileReady === 'true') return;
    const grid = section.querySelector('.rf-sc-whyus-grid');
    const feature = section.querySelector('.rf-sc-whyus-feature');
    const accordion = section.querySelector('.rf-sc-whyus-accordion');
    if (!grid || !feature || !accordion) return;
    section.dataset.rfWhyusMobileReady = 'true';

    function movePhoto() {
      if (breakpoint.matches) {
        const active = accordion.querySelector('.rf-sc-whyus-item.is-active');
        if (active && feature.nextElementSibling !== active) {
          accordion.insertBefore(feature, active);
        }
      } else if (feature.parentElement !== grid) {
        grid.insertBefore(feature, accordion);
      }
    }

    accordion.addEventListener('click', (event) => {
      if (!event.target.closest('.rf-sc-whyus-header')) return;
      // Accordion's own click handler updates is-active on the child first.
      movePhoto();
    });
    breakpoint.addEventListener('change', movePhoto);
    movePhoto();
  }

  function initAll(root) {
    root.querySelectorAll('.rf-sc-whyus-section').forEach(initWhyUs);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
